//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const customerRoutes = [
  {
    path: i18n.global.t('routes.customer.customerList'),
    name: Routes.CUSTOMER_LIST,
    component: () => import('@/components/customer/CustomerList.vue'),
    meta: {
      title: i18n.global.t('titles.customer.customerList'),
      active: 'customer',
      roles: [Permissions.ROLE_CUSTOMER_INDEX],
    },
  },
  {
    path: i18n.global.t('routes.customer.customerEdit'),
    name: Routes.CUSTOMER_EDIT,
    component: () => import('@/components/customer/CustomerEdit.vue'),
    meta: {
      title: i18n.global.t('titles.customer.customerEdit'),
      active: 'customer',
      roles: [Permissions.ROLE_CUSTOMER_EDIT],
    },
  },
  {
    path: i18n.global.t('routes.customer.customerCreate'),
    name: Routes.CUSTOMER_CREATE,
    component: () => import('@/components/customer/CustomerCreate.vue'),
    meta: {
      title: i18n.global.t('titles.customer.customerCreate'),
      active: 'customer',
      roles: [Permissions.ROLE_CUSTOMER_CREATE],
    },
  },
];
